<template>
  <CCard class="card">
    <CCardHeader>
      <span class="font-weight-bold font-xl">{{ $t('audience-new.import-contacts.choose-methods.title') }}</span>
    </CCardHeader>
    <div v-if="isLoadingCheckAudience" class="text-center">
      <CSpinner class="my-3" color="primary" />
    </div>
    <CCardBody v-else class="p-5">
      <div v-if="hasAudienceInProccess" class="d-flex flex-column justify-content-center align-items-center p-5">
        <CSpinner class="my-3" color="primary" />
        <p class="text-center mb-4">
          {{ $t('audience.importContacts.chooseMethods.text.processing-audience1') }} <br />
          {{ $t('audience.importContacts.chooseMethods.text.processing-audience2') }}
        </p>
        <CButton color="white" class="py-3 px-3">
          <router-link :to="{ name: 'home' }" tag="span">{{ $t('audience.importContacts.chooseMethods.link.go-to-dashboard') }}</router-link>
        </CButton>
      </div>
      <div v-else>
        <span class="font-weight-bold font-xl mb-5 mt-4 d-block ml-5">{{ $t('audience-new.import-contacts.choose-methods.how-to-import') }}</span>
        <div class="d-flex justify-content-between max-w-700 m-auto">
          <div class="w-280" v-for="importMethod in importMethods" :key="importMethod.type">
            <router-link :to="{ name: 'import', params: { type: importMethod.routeParam } }" tag="a">
              <div
                class="border-primary rounded m-auto w-190 h-125 cursor-pointer text-center d-flex justify-content-center flex-column hover-bg-gray"
              >
                <span><CIcon :name="importMethod.iconName" :height="50" viewBox="0 0 24 24" /></span>
                <span class="text-primary d-block font-weight-semi-bold mt-2">{{ importMethod.label }}</span>
              </div>
            </router-link>
            <p v-if="importMethod.type === IMPORT_TYPES.MANUAL" class="text-center mt-3 mb-0 font-sm">
              {{ $t('audience-new.import-contacts.choose-methods.manual-instruction') }}
            </p>
            <div
              @click="downloadSampleFile"
              v-if="importMethod.type === IMPORT_TYPES.FILE"
              class="underline-hover mt-3 text-primary cursor-pointer text-center"
            >
              <CIcon name="cilDataTransferDown" />
              <p class="ml-2 mb-0 font-sm d-inline">{{ $t('audience-new.import-contacts.choose-methods.download-sample') }}</p>
            </div>
          </div>
        </div>
        <CAlert class="mt-5 ml-5 mb-0 font-sm" color="info">
          <div class="d-flex align-items-baseline text-black">
            <div>
              <CIcon name="infoCircle" size="custom-size" class="mr-2" :height="15" style="transform: rotate(180deg)" viewBox="0 0 32 32" />
            </div>
            <p class="mb-0">
              {{ $t('audience-new.import-contacts.choose-methods.info') }}
            </p>
          </div>
        </CAlert>
      </div>
    </CCardBody>
  </CCard>
</template>

<script>
import { IMPORT_TYPES } from '../../constants'

export default {
  name: 'ChooseMethods',
  data() {
    return {
      IMPORT_TYPES,
      isLoadingCheckAudience: false,
    }
  },
  mounted() {
    this.isLoadingCheckAudience = true
    this.startAudienceCheckLoop()
  },
  beforeDestroy() {
    this.stopAudienceCheckLoop()
  },
  computed: {
    organizationId() {
      return this.$route.params.organizationId
    },
    importMethods() {
      return [
        {
          type: IMPORT_TYPES.FILE,
          label: this.$t('audience-new.import-contacts.choose-methods.file'),
          routeParam: 'upload',
          iconName: 'cilCloudUpload',
        },
        {
          type: IMPORT_TYPES.MANUAL,
          label: this.$t('audience-new.import-contacts.choose-methods.manual'),
          routeParam: 'manual',
          iconName: 'cilExcerpt',
        },
      ]
    },
    hasAudienceInProccess() {
      return this.$store.state.audience.statusAudience
    },
  },

  methods: {
    downloadSampleFile() {
      const fileUrl = 'https://static.arpoone.com/multichannel/audience/ArpooneSampleFile.xlsx'
      const fileName = 'ArpooneSampleFile'

      const link = document.createElement('a')
      link.href = fileUrl
      link.download = fileName

      document.body.appendChild(link)

      link.click()

      document.body.removeChild(link)
    },
    startAudienceCheckLoop() {
      this.checkAudienceInProcess()
      this.checkInterval = setInterval(this.checkAudienceInProcess, 5000)
    },
    stopAudienceCheckLoop() {
      if (this.checkInterval) {
        clearInterval(this.checkInterval)
        this.checkInterval = null
      }
    },
    async checkAudienceInProcess() {
      try {
        await this.$store.dispatch('audience/hasAudienceInProcess', this.organizationId)
      } finally {
        if (this.isLoadingCheckAudience) {
          this.isLoadingCheckAudience = false
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.card {
  max-width: 1000px;
}

.w-190 {
  width: 190px;
}

.w-280 {
  width: 280px;
}

.h-125 {
  height: 125px;
}

.underline-hover {
  &:hover {
    text-decoration: underline;
  }
}

.max-w-700 {
  max-width: 700px;
}

.max-w-1200 {
  max-width: 1200px;
}

.hover-bg-gray {
  &:hover {
    background-color: var(--gray-200);
  }
}
</style>
